import { ProductAccountDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';
import { UserClaim } from './user-claim.entity';

const defaultProductAccount: ProductAccountDto = {
    id: 0,
    name: '',
    number: '',
    userAccountClaims: [],
};

export class CompanyUserProductAccount extends DomainEntity<ProductAccountDto> {
    constructor(dto: ProductAccountDto) {
        super(dto);
        this.userAccountClaims = (this.dto.userAccountClaims ?? []).map(
            claim => new UserClaim(claim)
        );
    }

    public userAccountClaims: UserClaim[];

    public get id() {
        return this.dto.id;
    }

    public get name() {
        return this.dto.name;
    }

    public get number() {
        return this.dto.number;
    }

    public createDefault(): this {
        return new CompanyUserProductAccount(defaultProductAccount) as this;
    }
}

// export interface ProductAccountDto {
//     /** @format int32 */
//     id: number;
//     name?: string;
//     number?: string;
//     userAccountClaims?: UserClaimModelDto[];
//   }
